function referenceListing(editor) {
  // let currentNode = editor?.selection.getNode();
  // let parentNode = currentNode.parentNode;
  if (!editor.dom) return;
  let refs = getAllRefs(editor);
  if (refs) {
    let isAscending = checkAscending(refs, editor);
    // console.log(isAscending);
    if (isAscending) {
      return;
    } else {
      relistReference(editor, refs);
    }
  }
}

function getAllRefs(editor) {
  let refs = editor.dom.select("ref");
  return refs;
}

function checkAscending(refs, editor) {
  if (refs && refs.length > 0) {
    const refVal = refs.map((element) => editor.dom.getAttrib(element, "id"));

    const nums = refVal.map((id) => parseInt(id.replace(/\D/g, ""), 10));

    // Check for NaN values (invalid ID formats)
    if (nums.some(isNaN)) {
      //   console.warn("Invalid ID found in refs");
      return false;
    }

    if (nums[0] !== 1) {
      return false;
    }

    // Check if ascending and continuous
    for (let i = 0; i < nums.length - 1; i++) {
      if (nums[i + 1] !== nums[i] + 1) {
        return false;
      }
    }

    return true;
  }

  return false; // Fallback if refs is null or empty
}

function relistReference(editor, refs) {
  const xrefEles = editor?.dom.select("xref") || [];
  const refCits = xrefEles.filter(
    (ele) => editor.dom.getAttrib(ele, "ref-type") === "bibr"
  );

  const idMap = new Map();

  // Update ref IDs and map them
  for (let i = 0; i < refs.length; i++) {
    const oldId = editor.dom.getAttrib(refs[i], "id")?.trim();
    if (!oldId) continue; // Skip if no old ID

    const newId = `ref-${i + 1}`;
    idMap.set(oldId, newId);

    editor.dom.setAttrib(refs[i], "id", newId);
  }

  // Update xref citations based on the mapping
  refCits.forEach((cit) => {
    const oldRid = editor.dom.getAttrib(cit, "rid")?.trim();

    const newId = idMap.get(oldRid);

    if (newId) {
      const newNum = newId.split("-")[1]; // Extract number from ref-id
      editor.dom.setAttrib(cit, "rid", newId);
      editor.dom.setAttrib(cit, "href", `#${newId}`);
      editor.dom.setAttrib(cit, "data-mce-href", `#${newId}`);
      editor.dom.setHTML(cit, `${newNum}`); // Display the number in xref
    }
  });
}

function addReferenceTitle(editor) {
  let refs = editor?.dom?.select("ref");
  refs?.forEach((ref, i) => {
    const id = ref.getAttribute("id");

    const existingReftitle = Array.from(ref.children).find(
      (child) => child.tagName.toLowerCase() === "reftitle"
    );

    // Step 2: Remove it if exists
    if (existingReftitle) {
      editor.dom.remove(existingReftitle);
    }

    const reftitle = editor.dom.create(
      "reftitle",
      {
        "data-ref-title": "ref-title",
        contenteditableu: "true",
        "data-lock": "true",
        "data-edit": "edit",
      },
      `Reference-${id.replace("ref-", "")}`
    );

    // Append <reftitle> to the <ref> element
    editor.dom.add(ref, reftitle);
  });
}

function makeDataLockedElementsReadOnly(
  editor,
  dataAttr = "data-lock",
  value = "true"
) {
  const isLocked = (node) => {
    let current = node;
    while (current && current !== editor.getBody()) {
      const lockAttr = current.getAttribute(dataAttr);
      if (lockAttr === "false") return false; // explicitly editable
      if (lockAttr === value) return true; // locked
      current = current.parentNode;
    }
    return false;
  };

  editor.on("BeforeInput", (e) => {
    const node = editor.selection.getNode();
    if (isLocked(node)) {
      e.preventDefault();
    }
  });

  editor.on("keydown", (e) => {
    const node = editor.selection.getNode();
    if (isLocked(node)) {
      if (
        ["Backspace", "Delete", "Enter"].includes(e.key) ||
        (e.ctrlKey && ["x", "X"].includes(e.key))
      ) {
        e.preventDefault();
      }
    }
  });

  editor.on("PastePreProcess", (e) => {
    const node = editor.selection.getNode();
    if (isLocked(node)) {
      e.preventDefault();
    }
  });
}

function addRefrenceOutput(editor) {
  let refs = editor?.dom?.select("ref");
  console.log("come1",refs);


  refs?.forEach((ref, i) => {
    const id = ref?.getAttribute("id");
    const citation = ref?.querySelector("mixed-citation");
    let outputKey = ref?.getAttribute("key");

    const hasRefOutput = Array.from(ref.children).some(
      (child) => child.tagName.toLowerCase() === "refoutput"
    );
    const specificAttrName = "publication-type";
    const attrValue = citation?.getAttribute(specificAttrName);

    if (!hasRefOutput) {
      const refOutput = editor.dom.create(
        "refoutput",
        {
          "data-ref": "ref-output",
          key: `${outputKey}${id}`,
          contenteditable: "true",
          draggable: "false",
          "data-edit": "edit",
          "data-lock": "false",
        },
        citation ? citation.innerHTML : ``
      );
      // Append <refoutput> to the <ref> element
      refOutput.setAttribute(specificAttrName, attrValue);
      citation?.appendChild(refOutput);
      makeDataLockedElementsReadOnly(editor);
    }
  });
}

function formatRefOutput(refoutputElement) {
  if (!refoutputElement) return "";

  let authors = [];
  const personGroup = refoutputElement.querySelector("person-group");
  if (personGroup) {
    const stringNames = personGroup.querySelectorAll("string-name");
    stringNames.forEach((name) => {
      const given = name.querySelector("given-name")?.innerText.trim() || "";
      const sur = name.querySelector("sur-name")?.innerText.trim() || "";
      if (given && sur) {
        authors.push(`${sur} ${given}`);
      }
    });
  }

  const articleTitle =
    refoutputElement.querySelector("article-title")?.innerText.trim() || "";
  const source1 =
    refoutputElement.querySelector("source1")?.innerText.trim() || "";
  const publisher =
    refoutputElement.querySelector("publisher-name")?.innerText.trim() || "";
  const year = refoutputElement.querySelector("year")?.innerText.trim() || "";
  const volume =
    refoutputElement.querySelector("volume")?.innerText.trim() || "";
  const issue = refoutputElement.querySelector("issue")?.innerText.trim() || "";
  const fpage = refoutputElement.querySelector("fpage")?.innerText.trim() || "";
  const lpage = refoutputElement.querySelector("lpage")?.innerText.trim() || "";
  const doi =
    refoutputElement
      .querySelector("pub-id[pub-id-type='uri']")
      ?.innerText.trim() || "";

  let formatted = "";

  if (authors.length) {
    formatted += authors.join(", ") ;
  }
  if (articleTitle) {
    formatted += articleTitle ;
  }
  if (source1) {
    formatted += source1;
  }
  if (publisher) {
    formatted += publisher ;
  }
  if (year) {
    formatted += year;
  }
  if (volume) {
    formatted += `;${volume}`;
    if (issue) {
      formatted += `(${issue})`;
    }
  }
  if (fpage && lpage) {
    formatted += `:${fpage}–${lpage}`;
  }
  if (doi) {
    formatted += `https://doi.org/${doi}`;
  }

  //  Fallback to dynamic traversal if fixed method fails
  if (!formatted.trim()) {
    formatted = dynamicFallback(refoutputElement);
  }

  // Clean up spaces and periods
  return formatted
    .replace(/\s+/g, " ") // Collapse spaces // Ensure ending period
    .trim();
}

// Dynamic fallback for unexpected tag structures
function dynamicFallback(node) {
  let text = "";
  node.childNodes.forEach((child) => {
    if (child.nodeType === Node.TEXT_NODE) {
      text += child.textContent.trim() + " ";
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      text += dynamicFallback(child);
    }
  });
  return text.trim();
}

export {
  referenceListing,
  addReferenceTitle,
  addRefrenceOutput,
  formatRefOutput,
};
